// src/components/app-shell/AppShellUI.ts
import { html } from 'lit'
import { AppShell } from './AppShell'

export class AppShellUI {
    constructor(private appShell: AppShell) {}

    render() {
        return html`
            <chat-container
                .chats=${this.appShell._chats}
                .selectedChatId=${this.appShell._selectedChatId}
                .messages=${this.appShell._messages}
                .showChatList=${this.appShell._showChatList}
                .isMobile=${this.appShell._isMobile}
                @chat-selected=${this.appShell.handlers.handleChatSelected}
                @message-submit=${this.appShell.handlers.handleMessageSubmit}
                @new-chat-requested=${this.appShell.handlers.handleNewChatRequested}
                @toggle-chat-list=${this.appShell.handlers.toggleChatList}
            ></chat-container>
        `
    }
}
